/** Shared scroll lock while any PDP side drawer is open (iOS needs body position:fixed). */
var pdpSidebarScrollLockCount = 0;
var pdpSidebarSavedScrollY = 0;
var pdpSidebarTouchGuardReady = false;
var pdpSidebarTouchLastY = 0;

/** Ignore sidebar-trigger clicks until the page has fully finished loading. */
var pdpSidebarPageLoaded = document.readyState === 'complete';
if (!pdpSidebarPageLoaded) {
  window.addEventListener('load', function () {
    pdpSidebarPageLoaded = true;
  }, { once: true });
}

function isPdpSidebarOpen() {
  return !!document.querySelector('.pdp-sidebar.is-open, .klaviyo-bis__panel.is-open');
}
window.isPdpSidebarOpen = isPdpSidebarOpen;

function bindPdpSidebarTouchGuard() {
  if (pdpSidebarTouchGuardReady) return;
  pdpSidebarTouchGuardReady = true;
  document.addEventListener(
    'touchstart',
    function (e) {
      if (!isPdpSidebarOpen()) return;
      pdpSidebarTouchLastY = e.touches[0].clientY;
    },
    { passive: true }
  );
  document.addEventListener(
    'touchmove',
    function (e) {
      if (!isPdpSidebarOpen()) return;
      var drawerBody = e.target.closest('.pdp-sidebar__body, .klaviyo-bis__body');
      if (drawerBody) {
        var y = e.touches[0].clientY;
        var dy = pdpSidebarTouchLastY - y;
        pdpSidebarTouchLastY = y;
        var scrollable = drawerBody.scrollHeight > drawerBody.clientHeight + 2;
        if (!scrollable) {
          if (e.cancelable) e.preventDefault();
          return;
        }
        var atTop = drawerBody.scrollTop <= 0;
        var atBottom =
          drawerBody.scrollTop + drawerBody.clientHeight >= drawerBody.scrollHeight - 1;
        if ((atTop && dy < 0) || (atBottom && dy > 0)) {
          if (e.cancelable) e.preventDefault();
        }
        return;
      }
      if (e.cancelable) e.preventDefault();
    },
    { passive: false }
  );
}

function lockPdpSidebarPageScroll() {
  pdpSidebarScrollLockCount += 1;
  if (pdpSidebarScrollLockCount > 1) return;
  bindPdpSidebarTouchGuard();
  pdpSidebarSavedScrollY = window.scrollY;
  document.documentElement.classList.add('pdp-sidebar-scroll-lock');
  document.body.classList.add('pdp-sidebar-scroll-lock');
  document.documentElement.style.overflow = 'hidden';
  document.body.style.setProperty('position', 'fixed', 'important');
  document.body.style.setProperty('top', '-' + pdpSidebarSavedScrollY + 'px', 'important');
  document.body.style.setProperty('left', '0', 'important');
  document.body.style.setProperty('right', '0', 'important');
  document.body.style.setProperty('width', '100%', 'important');
  document.body.style.setProperty('overflow', 'hidden', 'important');
}

function unlockPdpSidebarPageScroll() {
  pdpSidebarScrollLockCount = Math.max(0, pdpSidebarScrollLockCount - 1);
  if (pdpSidebarScrollLockCount > 0) return;
  var scrollY = pdpSidebarSavedScrollY;
  document.documentElement.classList.remove('pdp-sidebar-scroll-lock');
  document.body.classList.remove('pdp-sidebar-scroll-lock');
  document.documentElement.style.overflow = '';
  document.body.style.removeProperty('position');
  document.body.style.removeProperty('top');
  document.body.style.removeProperty('left');
  document.body.style.removeProperty('right');
  document.body.style.removeProperty('width');
  document.body.style.removeProperty('overflow');
  requestAnimationFrame(function () {
    window.scrollTo(0, scrollY);
  });
}

class PdpSidebarPanel extends HTMLElement {
  connectedCallback() {
    if (this._init) return;
    this._init = true;

    // Move the panel to <body> so it escapes the section's stacking context
    // and sits above the sticky header (z-index: 1001 vs header's sticky context)
    document.body.appendChild(this);

    const sidebarId = this.dataset.sidebarId;
    const overlay = this.querySelector('.pdp-sidebar-overlay');
    const panel = this.querySelector('.pdp-sidebar');
    const body = this.querySelector('.pdp-sidebar__body');
    const closeBtn = this.querySelector('.pdp-sidebar__close');
    // this.desktopScrollbarMediaQuery = window.matchMedia('(min-width: 768px)');

    const lockScroll = () => {
      lockPdpSidebarPageScroll();
    };

    const unlockScroll = () => {
      unlockPdpSidebarPageScroll();
    };

    // .section-header (the Shopify section wrapper, a body grid item) is what carries
    // position:sticky/z-index — pinning IT to position:fixed (as window.pdpPinHeader does
    // for the Kiwi flow) pulls it out of the grid entirely, so its track collapses and
    // #MainContent snaps up by one header-height the instant the panel opens. Instead,
    // lock .section-header's own height (keeps its grid track reserved) and only make
    // the inner <sticky-header> element position:fixed, so it pins to the real viewport
    // without disturbing the outer layout.
    const pinHeaderNoShift = () => {
      const sectionHeader = document.querySelector('.section-header');
      const stickyHeaderEl = document.querySelector('sticky-header');
      if (!sectionHeader || !stickyHeaderEl) return;
      const h = sectionHeader.getBoundingClientRect().height;
      sectionHeader.style.setProperty('height', h + 'px', 'important');
      sectionHeader.style.setProperty('min-height', h + 'px', 'important');
      stickyHeaderEl.style.setProperty('position', 'fixed', 'important');
      stickyHeaderEl.style.setProperty('top', '0', 'important');
      stickyHeaderEl.style.setProperty('left', '0', 'important');
      stickyHeaderEl.style.setProperty('right', '0', 'important');
      stickyHeaderEl.style.setProperty('z-index', '99999', 'important');
    };

    const unpinHeaderNoShift = () => {
      const sectionHeader = document.querySelector('.section-header');
      const stickyHeaderEl = document.querySelector('sticky-header');
      if (sectionHeader) {
        sectionHeader.style.removeProperty('height');
        sectionHeader.style.removeProperty('min-height');
      }
      if (stickyHeaderEl) {
        stickyHeaderEl.style.removeProperty('position');
        stickyHeaderEl.style.removeProperty('top');
        stickyHeaderEl.style.removeProperty('left');
        stickyHeaderEl.style.removeProperty('right');
        stickyHeaderEl.style.removeProperty('z-index');
      }
    };

    const freezeHeader = () => {
      if (window._parallaxFreezeHeader) {
        window._parallaxFreezeHeader();
        return;
      }
      const stickyHeader = document.querySelector('sticky-header');
      if (!stickyHeader) return;
      stickyHeader.preventHide = true;
      if (stickyHeader.onScrollHandler) {
        window.removeEventListener('scroll', stickyHeader.onScrollHandler);
      }
      if (!stickyHeader.header.classList.contains('shopify-section-header-hidden')) {
        stickyHeader.reveal();
      }
    };

    const unfreezeHeader = () => {
      if (window.__pdpKiwiSettling) return;
      if (window._parallaxThawHeader) {
        window._parallaxThawHeader();
        return;
      }
      const stickyHeader = document.querySelector('sticky-header');
      if (!stickyHeader) return;
      stickyHeader.preventHide = false;
      if (stickyHeader.onScrollHandler) {
        window.removeEventListener('scroll', stickyHeader.onScrollHandler);
        setTimeout(() => {
          if (stickyHeader.onScrollHandler) {
            stickyHeader.currentScrollTop = window.scrollY;
            window.addEventListener('scroll', stickyHeader.onScrollHandler, false);
          }
        }, 100);
      }
    };

    const open = () => {
      panel.classList.remove('is-closing');
      overlay.classList.remove('is-closing');

      // Show overlay first (display: block), then fade in on next frame
      overlay.style.display = 'block';
      requestAnimationFrame(() => {
        overlay.classList.add('is-open');
        panel.classList.add('is-open');
      });

      // Pin BEFORE the scroll lock — reads offsetHeight while body is still in normal flow.
      pinHeaderNoShift();
      lockScroll();
      freezeHeader();
      closeBtn.focus();
    };

    const close = () => {
      panel.classList.add('is-closing');
      overlay.classList.remove('is-open');
      overlay.classList.add('is-closing');
      // Restore scroll immediately, while overlay is still fully opaque —
      // iOS's body position:fixed removal snaps the page instantly, and if
      // that happens after the overlay has started fading (previous approach:
      // unlock on panel transitionend) the background is briefly visible
      // through the semi-transparent overlay = flash. Unlocking now hides
      // the jump behind the still-opaque overlay.
      unpinHeaderNoShift();
      unlockScroll();
      // unfreezeHeader AFTER unlockScroll — releasing preventHide before scroll is
      // restored lets sticky-header's onScroll fire with stale position = header flash.

      const onTransitionEnd = () => {
        panel.classList.remove('is-open', 'is-closing');
        overlay.classList.remove('is-closing');
        overlay.style.display = 'none';
        unfreezeHeader();
        panel.removeEventListener('transitionend', onTransitionEnd);
      };

      panel.addEventListener('transitionend', onTransitionEnd);

      // Fallback in case transitionend doesn't fire
      setTimeout(() => {
        if (panel.classList.contains('is-closing')) {
          panel.classList.remove('is-open', 'is-closing');
          overlay.classList.remove('is-closing');
          overlay.style.display = 'none';
          unfreezeHeader();
        }
      }, 650);
    };

    const isSizeFitTrigger = (btn) => btn.dataset.sizeGuideTrigger === 'true';

    const KIWI_SEL = '.ks-chart-modal-link, .ks-chart-modal-button, .ks-calculator-modal-link, .ks-calculator-modal-button';
    const CHART_SEL = '#KiwiSizingChart, [data-kiwi-size-chart]';
    let kiwiTrigger = null;
    let kiwiReady = false;
    let kiwiObserver = null;
    let kiwiObserverTimeout = null;

    const fireKiwi = (el) => el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
    const sizeGuideButtons = () => Array.from(document.querySelectorAll(`[data-sidebar-target="${sidebarId}"]`)).filter(isSizeFitTrigger);
    const setSizeGuideVisible = (visible) => sizeGuideButtons().forEach((b) => { b.hidden = !visible; b.style.visibility = visible ? 'visible' : 'hidden'; });

    const watchChart = (chart) => {
      kiwiObserver?.disconnect();
      clearTimeout(kiwiObserverTimeout);
      kiwiTrigger = null;
      kiwiReady = false;
      setSizeGuideVisible(true);

      kiwiObserver = new MutationObserver(() => {
        clearTimeout(kiwiObserverTimeout);
        kiwiObserverTimeout = setTimeout(() => {
          kiwiTrigger = chart.querySelector(KIWI_SEL) || chart.querySelector('a, button') || null;
          if (kiwiTrigger) { kiwiReady = true; kiwiObserver?.disconnect(); }
        }, 100);
      });
      kiwiObserver.observe(chart, { childList: true, subtree: true });
      kiwiObserver.takeRecords(); // flush sync

      // run initial scan
      kiwiTrigger = chart.querySelector(KIWI_SEL) || chart.querySelector('a, button') || null;
      if (kiwiTrigger) { kiwiReady = true; kiwiObserver.disconnect(); }

      setTimeout(() => { kiwiReady = true; }, 5000);
    };

    const initChart = document.querySelector(CHART_SEL);
    if (!initChart || !sizeGuideButtons().length) {
      kiwiReady = true;
      if (!initChart) setSizeGuideVisible(false);
    } else {
      watchChart(initChart);
    }

    document.addEventListener('kiwi:reloaded', (e) => {
      const c = e.detail?.chart || document.querySelector(CHART_SEL);
      if (c) watchChart(c);
    });

    const handleTriggerClick = (e) => {
      const btn = e.target.closest(`[data-sidebar-target="${sidebarId}"]`);
      if (!btn) return;

      if (!isSizeFitTrigger(btn)) { open(); return; }

      if (kiwiTrigger) {
        e.preventDefault(); e.stopPropagation();
        if (typeof window.__pdpKiwiPrepareOpen === 'function') {
          window.__pdpKiwiPrepareOpen(pdpSidebarSavedScrollY || window.scrollY);
        }
        fireKiwi(kiwiTrigger);
        // Re-attach scroll listener and unfreeze when Kiwi modal fully closes.
        // Watch both style (overflow:hidden) and class changes — Kiwi uses either approach.
        const isKiwiOpen = () =>
          document.body.style.overflow === 'hidden' ||
          document.body.style.position === 'fixed' ||
          document.querySelector('.kiwi-sizing-modal-visible, .vanilla-modal-visible') !== null;
        const finishKiwiClose = () => {
          const y =
            window.__pdpKiwiScrollGuardState && window.__pdpKiwiScrollGuardState.hasSavedScroll
              ? window.__pdpKiwiScrollGuardState.scrollY
              : pdpSidebarSavedScrollY;
          if (typeof window.__pdpSettleAfterKiwiClose === 'function') {
            window.__pdpSettleAfterKiwiClose(y, null);
          } else if (window._parallaxThawHeader) {
            window._parallaxThawHeader();
          }
        };
        const watchKiwiClose = new MutationObserver(() => {
          if (!isKiwiOpen()) {
            watchKiwiClose.disconnect();
            finishKiwiClose();
          }
        });
        watchKiwiClose.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
        if (document.documentElement) {
          watchKiwiClose.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        }
        return;
      }
      if (kiwiReady || !document.querySelector(CHART_SEL)) { if (pdpSidebarPageLoaded) open(); return; }

      e.preventDefault(); e.stopPropagation();
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      const done = (action) => { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); action(); };

      const start = Date.now();
      const wait = setInterval(() => {
        if (kiwiTrigger) {
          clearInterval(wait);
          done(() => {
            if (typeof window.__pdpKiwiPrepareOpen === 'function') {
              window.__pdpKiwiPrepareOpen(pdpSidebarSavedScrollY || window.scrollY);
            }
            fireKiwi(kiwiTrigger);
            const isKiwiOpen2 = () =>
              document.body.style.overflow === 'hidden' ||
              document.body.style.position === 'fixed' ||
              document.querySelector('.kiwi-sizing-modal-visible, .vanilla-modal-visible') !== null;
            const finishKiwiClose2 = () => {
              const y =
                window.__pdpKiwiScrollGuardState && window.__pdpKiwiScrollGuardState.hasSavedScroll
                  ? window.__pdpKiwiScrollGuardState.scrollY
                  : pdpSidebarSavedScrollY;
              if (typeof window.__pdpSettleAfterKiwiClose === 'function') {
                window.__pdpSettleAfterKiwiClose(y, null);
              } else if (window._parallaxThawHeader) {
                window._parallaxThawHeader();
              }
            };
            const w2 = new MutationObserver(() => {
              if (!isKiwiOpen2()) {
                w2.disconnect();
                finishKiwiClose2();
              }
            });
            w2.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
            if (document.documentElement) {
              w2.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
            }
          });
        }
        else if (kiwiReady || Date.now() - start > 150) { clearInterval(wait); done(() => { if (pdpSidebarPageLoaded) open(); }); }
      }, 50);
    };

    document.addEventListener('click', handleTriggerClick);
    closeBtn.addEventListener('click', close);
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('is-open')) close();
    });
  }

}

customElements.define('pdp-sidebar-panel', PdpSidebarPanel);

// Shop the Look — smooth scroll on desktop, accordion on mobile
document.querySelectorAll('.pdp-sidebar-trigger--scroll').forEach((btn) => {
  btn.addEventListener('click', () => {
    const targetId = btn.dataset.scrollTo;
    const target = document.getElementById(targetId);
    if (!target) return;

    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      // Mobile: accordion behavior
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      const plusIcon = btn.querySelector('.pdp-sidebar-trigger__icon--plus');
      const minusIcon = btn.querySelector('.pdp-sidebar-trigger__icon--minus');
      
      if (isExpanded) {
        // Collapse
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('is-open');
        target.classList.add('is-collapsed');
        target.style.maxHeight = '0';
        target.style.opacity = '0';
        
        // Show plus icon, hide minus icon
        if (plusIcon) {
          plusIcon.style.display = '';
          plusIcon.setAttribute('aria-hidden', 'true');
        }
        if (minusIcon) {
          minusIcon.style.display = 'none';
          minusIcon.setAttribute('aria-hidden', 'false');
        }
      } else {
        // Expand
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('is-open');
        target.classList.remove('is-collapsed');
        target.style.maxHeight = target.scrollHeight + 'px';
        target.style.opacity = '1';
        
        // Hide plus icon, show minus icon
        if (plusIcon) {
          plusIcon.style.display = 'none';
          plusIcon.setAttribute('aria-hidden', 'false');
        }
        if (minusIcon) {
          minusIcon.style.display = '';
          minusIcon.setAttribute('aria-hidden', 'true');
        }
        
        // Scroll to the button after expansion
        setTimeout(() => {
          btn.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }, 300);
      }
    } else {
      // Desktop: smooth scroll behavior
      const start = window.scrollY;
      const end = target.getBoundingClientRect().top + window.scrollY - 0;
      const distance = end - start;
      const duration = 700;
      let startTime = null;

      function easeInOutCubic(t) {
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / duration, 1);
        window.scrollTo(0, start + distance * easeInOutCubic(progress));
        if (progress < 1) requestAnimationFrame(step);
      }

      requestAnimationFrame(step);
    }
  });
});

// Preserve scroll when Kiwi's own modal locks/unlocks body overflow.
// Guard prevents double-registration when product-card.js also loads on PDP.
(function () {
  if (window._kiwiScrollGuardInit) return;
  window._kiwiScrollGuardInit = true;

  let _kiwiScrollY = null;

  new MutationObserver(() => {
    const kiwiModalVisible =
      document.body.classList.contains('kiwi-sizing-modal-visible') ||
      document.documentElement.classList.contains('kiwi-sizing-modal-visible') ||
      !!document.querySelector('.kiwi-sizing-modal-visible, .vanilla-modal-visible');
    const isSidebarLock = !!document.querySelector('.pdp-sidebar.is-open, .pdp-sidebar.is-closing');

    if (kiwiModalVisible && !isSidebarLock && _kiwiScrollY === null) {
      const guard = window.__pdpKiwiScrollGuardState;
      const bodyTop = parseInt(document.body.style.top || '0', 10);
      if (guard && guard.hasSavedScroll) {
        _kiwiScrollY = guard.scrollY;
      } else if (bodyTop < 0) {
        _kiwiScrollY = -bodyTop;
      } else {
        _kiwiScrollY = window.scrollY || 0;
      }
      if (window.__pdpKiwiSaveScrollPosition) window.__pdpKiwiSaveScrollPosition(_kiwiScrollY);
    } else if (!kiwiModalVisible && _kiwiScrollY !== null) {
      const y = _kiwiScrollY;
      _kiwiScrollY = null;
      if (typeof window.__pdpSettleAfterKiwiClose === 'function') {
        window.__pdpSettleAfterKiwiClose(y, null);
      } else {
        requestAnimationFrame(function () {
          window.scrollTo(0, y);
          requestAnimationFrame(function () {
            if (window._parallaxThawHeader) window._parallaxThawHeader();
          });
        });
      }
    }
  }).observe(document.body, { attributes: true, attributeFilter: ['style'] });
}());
